// src/components/StepForm/StepForm.jsx

import React, { useState, useEffect, useRef } from "react";
import StepSidebar from "./StepSidebar";
import Step1 from "./step1/Step";
import Step2 from "./step2/Step";
import Step3 from "./step3/Step";
import Step4 from "./step4/Step";
import "./StepForm.css";
import CommonBreadcrumb from "./../common_components/breadcrumb/CommonBreadcrumb";

const StepForm = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const stepContentRef = useRef(null);
  const [formData, setFormData] = useState({
    country: "",
    documentType: "",
    fullName: "",
    address: "",
    bankName: "",
    accountNumber: "",
  });

  const nextStep = () => {
    if (currentStep < 4) setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  useEffect(() => {
    if (window.innerWidth <= 768) {
      const yOffset = -400; 
      const element = stepContentRef.current;
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    }
  }, [currentStep]);
  
  const breadcrumbItems = [
    { label: "Profile", link: "/profile" },
    { label: "Wallet & Earnings" },
  ];
  return (
    <section className="step-form-section ">
      <CommonBreadcrumb items={breadcrumbItems} />
      <div className="container px-lg-8   step-container">
        <StepSidebar currentStep={currentStep} />

        <div ref={stepContentRef} className="step-content">
          {currentStep === 1 && (
            <Step1
              formData={formData}
              setFormData={setFormData}
              onNext={nextStep}
            />
          )}
          {currentStep === 2 && (
            <Step2
              formData={formData}
              setFormData={setFormData}
              onNext={nextStep}
              onBack={prevStep}
            />
          )}
          {currentStep === 3 && (
            <Step3
              formData={formData}
              setFormData={setFormData}
              onNext={nextStep}
              onBack={prevStep}
            />
          )}
          {currentStep === 4 && <Step4 formData={formData} onBack={prevStep} />}
        </div>
      </div>
    </section>
  );
};

export default StepForm;
